import { RULE_SEVERITIES } from '../statistics';

/**
 * Derives the rule severity from its affected resources: the highest
 * severity found among spec.resources[].severity. Returns undefined when
 * the rule has no resources with a known severity.
 */
export function getRuleSeverityFromResources(
  resources: Array<{ severity?: string }> | undefined,
): string | undefined {
  const severities = (resources ?? [])
    .map(resource => resource.severity ?? '')
    .filter(Boolean);
  return RULE_SEVERITIES.find(severity => severities.includes(severity));
}
